
import { useRef, useState } from "react";
import styles from "../FieldTypeModal.module.scss";
import { CirclePlusIcon, DeleteIcon, DragIndicatorIcon } from "../../../../../../../assets/icons";
import ToggleButton from "../../../../../../../common/components/toggle-button/ToggleButton";
import { ChoseBoolFiledConfig } from "./shared/ChooseBool";
import Button from "../../../../../../../common/components/xepp/button/Button";
import { InputWithClearFiledConfig } from "./shared/InputWithClear";
import { Attribute, FieldType } from "../../../../../../../model/service-request/attribute";
import { v4 as uuidv4 } from 'uuid';

type Props = {
    onFieldSave: (attr: Attribute) => void
    existingAttribute?: Attribute
}

export const DropdownFiledConfiguration = (props: Props) => {
    const [attribute, setAttribute] = useState<Attribute>({

        id: props.existingAttribute ? props.existingAttribute.id : uuidv4(),
        label: props.existingAttribute ? props.existingAttribute.label : "",
        isRequired: props.existingAttribute ? props.existingAttribute.isRequired : false,
        isEnabled: props.existingAttribute ? props.existingAttribute.isEnabled : true,
        isSingleType: props.existingAttribute ? props.existingAttribute.isSingleType : true,
        childrenOptionDefinitions: props.existingAttribute ? props.existingAttribute.childrenOptionDefinitions : [{ value: "" }, { value: "" }],
        fieldType: FieldType.Dropdown,
    });


    const dragPerson = useRef<number>(0)
    const draggedOverPerson = useRef<number>(0)

    function handleSort(sectionIndex: number) {
        var newOptions = [...attribute.childrenOptionDefinitions!];

        const draggedItem = newOptions[dragPerson.current];
        // remove the dragged item
        newOptions.splice(dragPerson.current, 1);
        // insert it at the new position
        newOptions.splice(draggedOverPerson.current, 0, draggedItem);

        newOptions = newOptions.map((x, i) => { return { ...x, displayOrder: i + 1 } });
        setAttribute({ ...attribute, childrenOptionDefinitions: newOptions })
    }

    const clearFieldName = () =>
        setAttribute({ ...attribute, label: "" });

    const addNewOption = () => {
        setAttribute({ ...attribute, childrenOptionDefinitions: [...attribute.childrenOptionDefinitions!, { value: "" }] })
    }

    return <div>
        <div className={styles.configurationForm}>
            <InputWithClearFiledConfig
                onChange={(val: string) => {
                    setAttribute({ ...attribute, label: val })
                }}
                onClear={clearFieldName}
                filedLabel="Field Name"
                value={attribute.label}
                placeholederText="Enter Field Name"
            />

            <ChoseBoolFiledConfig
                onChange={(val: boolean) => {
                    setAttribute({ ...attribute, isRequired: val });
                }
                }
                value={attribute.isRequired}
                option1="Yes"
                option2="No"
                fieldLabel={"Required"}
            />

            <div className={styles.configurationField}>
                <div className={styles.title}>
                    <span className={styles.label}>Dropdown options</span>
                    <div className={styles.actionButton} onClick={addNewOption}>
                        <span className={styles.label}>Add Option</span>
                        <CirclePlusIcon />
                    </div>
                </div>
                <div className={styles.body}>
                    {
                        attribute.childrenOptionDefinitions && attribute.childrenOptionDefinitions.map(
                            (option, i) => {
                                return <div className={styles.optionValue} key={`option-${i}`}
                                    draggable
                                    onDragStart={() => (dragPerson.current = i)}
                                    onDragEnter={() => (draggedOverPerson.current = i)}
                                    onDragEnd={() => { handleSort(i) }}
                                    onDragOver={(e) => e.preventDefault()}
                                >
                                    <div className={styles.dragInput} >
                                        <DragIndicatorIcon className={styles.icon} />
                                        <input
                                            type="text"
                                            value={option.value}
                                            onChange={(e) => {
                                                const newOptions = attribute.childrenOptionDefinitions!.map((opt, index) =>
                                                    index === i ? { ...opt, value: e.target.value } : opt
                                                );

                                                setAttribute({
                                                    ...attribute,
                                                    childrenOptionDefinitions: newOptions,
                                                });
                                            }
                                            }
                                            placeholder={option.value ? "" : `Option ${i + 1}`}
                                        />
                                    </div>
                                    {option.value && <DeleteIcon className={styles.deleteOption} onClick={() => {
                                        setAttribute({ ...attribute, childrenOptionDefinitions: attribute.childrenOptionDefinitions?.filter(x => x != option) })
                                    }} />}
                                </div>
                            }
                        )

                    }
                </div>
            </div>
            <div className={styles.configurationField}>
                <div className={styles.title}>
                    <span className={styles.label}>Selection Type</span>
                </div>
                <div className={styles.body}>
                    <div className={styles.toggleOption}>
                        <span>Multiple</span>
                        <ToggleButton value={!attribute.isSingleType} onToggle={() => {
                            setAttribute({ ...attribute, isSingleType: false })
                        }} />
                    </div>
                    <div className={styles.toggleOption}>
                        <span>Single</span>
                        <ToggleButton value={attribute.isSingleType} onToggle={() => {
                            setAttribute({ ...attribute, isSingleType: true })
                        }} />
                    </div>
                </div>
            </div>
        </div>
        <div className={styles.saveField}>
            <Button onClick={() => { props.onFieldSave(attribute) }} variant="secondary" text="Save Field" className={styles.saveFieldBtn} />
        </div>
    </div>
}